
import { Component, Vue, PropSync, Prop, Watch } from 'vue-property-decorator';
import { constructionScopeType,subjectType} from '@/interfaces/virtualTeachingAndResearchSectionCommonType';
import {virtualPurviewSetting} from '@/utils/utils'

@Component({
  name: 'TeachingInfo',
  components: {},
})
export default class TeachingInfo extends Vue {
  @PropSync('show', { type: Boolean, default: true }) syncedShow!: boolean;
  @Prop({ type: Object, default: {} }) readonly panelData!: any;
  constructionScopeType = constructionScopeType;
  subjectType = subjectType;
  verify = virtualPurviewSetting
  get officeDetails() {
    return this.$store.state.officeDetails;
  }
  created() {}
  closeDialog() {
    this.syncedShow = false;
  }
}
